(() => {
  const initStickyAtc = (bar) => {
    if (!bar || bar.dataset.stickyReady === 'true') return;

    const sectionId = bar.dataset.sectionId;
    const mainProduct = document.getElementById(`MainProduct-${sectionId}`);
    const stickyInput = bar.querySelector('[data-sticky-atc-variant-id]');
    const stickyButton = bar.querySelector('button[name="add"]');
    const stickyButtonText = bar.querySelector('[data-sticky-atc-button-text]');
    const stickyPrice = bar.querySelector('[data-sticky-atc-price]');
    const stickyVariant = bar.querySelector('[data-sticky-atc-variant]');
    const stickyImage = bar.querySelector('.sticky-atc__image');
    const variantsNode = bar.querySelector('[data-sticky-atc-variants]');

    if (!mainProduct || !stickyInput || !stickyButton || !variantsNode) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    const variantsById = new Map(variants.map((variant) => [String(variant.id), variant]));
    let mainButton = null;
    let frame = null;

    const refreshMainButton = () => {
      mainButton = mainProduct.querySelector('[id^="ProductSubmitButton-"], product-form button[name="add"]');
    };

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('sticky-atc-active', visible);
      if (visible) {
        document.documentElement.style.setProperty('--sticky-atc-height', `${bar.offsetHeight}px`);
      }
    };

    const updateVisibility = () => {
      frame = null;
      refreshMainButton();
      if (!mainButton) {
        setVisible(false);
        return;
      }
      setVisible(mainButton.getBoundingClientRect().bottom < 0);
    };

    const requestVisibilityUpdate = () => {
      if (frame) return;
      frame = requestAnimationFrame(updateVisibility);
    };

    const syncButtonState = () => {
      refreshMainButton();
      if (!mainButton) return;
      const loading = mainButton.classList.contains('loading');
      const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
      stickyButton.classList.toggle('loading', loading);
      stickyButton.querySelector('.loading-overlay__spinner')?.classList.toggle('hidden', !loading);
    };

    const applyVariant = (variant) => {
      if (!variant) {
        stickyInput.value = '';
        stickyButton.disabled = true;
        stickyButton.setAttribute('aria-disabled', 'true');
        if (stickyButtonText) stickyButtonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
        return;
      }

      stickyInput.value = variant.id;
      stickyButton.disabled = !variant.available;
      stickyButton.toggleAttribute('aria-disabled', !variant.available);
      if (stickyButtonText) {
        stickyButtonText.textContent = variant.available
          ? window.variantStrings?.addToCart || 'Add to cart'
          : window.variantStrings?.soldOut || 'Sold out';
      }
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (stickyVariant) stickyVariant.textContent = variant.title;
      if (stickyImage && variant.image) stickyImage.src = variant.image;
    };

    const syncFromMainForm = () => {
      const mainInput = mainProduct.querySelector('form[action*="/cart/add"] input[name="id"]');
      const variant = mainInput ? variantsById.get(String(mainInput.value)) : null;
      if (variant) applyVariant(variant);
    };

    refreshMainButton();
    syncFromMainForm();
    bar.hidden = false;
    bar.dataset.stickyReady = 'true';
    updateVisibility();

    window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
    window.addEventListener('resize', requestVisibilityUpdate, { passive: true });
    mainProduct.addEventListener('change', () => requestAnimationFrame(syncFromMainForm));

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, (event) => {
        const eventSection = event?.data?.sectionId;
        if (eventSection && String(eventSection) !== String(sectionId)) return;
        const eventVariant = event?.data?.variant || event?.variant;
        if (eventVariant?.id) {
          applyVariant(variantsById.get(String(eventVariant.id)) || eventVariant);
        } else {
          syncFromMainForm();
        }
        requestVisibilityUpdate();
      });
    }

    const observer = new MutationObserver(() => {
      syncFromMainForm();
      syncButtonState();
      requestVisibilityUpdate();
    });
    observer.observe(mainProduct, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'value'],
    });
  };

  const initAllStickyAtc = (root = document) => {
    root.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllStickyAtc());
  } else {
    initAllStickyAtc();
  }

  document.addEventListener('shopify:section:load', (event) => initAllStickyAtc(event.target));
})();
